/**
 * Creates a BEM class list based on a block, an optional element, and optional modifiers.
 * @param block The block for the BEM class.
 * @param element The element for the BEM class.
 * @param modifiers An object containing modifiers as keys set to booleans.
 * If the value of the key is true they will be added, if false, they will not be added.
 * @returns The space separated class list as a string.
 */
export function bemClass(block, element = '', modifiers = {}) {
    if (!block) {
        throw new Error('BEM classes must have a block');
    }
    const base = element ? `${block}__${element}` : block;
    return Object.keys(modifiers).reduce((classes, modifier) => {
        if (modifiers[modifier]) {
            return classes + ` ${base}--${kebabize(modifier)}`;
        }
        return classes;
    }, base);
}
/**
 * Creates and configures a new HTML element with attributes
 * @param elementName The name of the HTML element to be created.
 * @param properties An object containing attributes as keys set to their attribute values.
 * Boolean properties should be set with a boolean, not with an empty string.
 * Attributes set to empty strings will not be added
 * @returns An HTMLElement of the type passed with attribues set.
 */
export function createElementWithProperties(elementName, properties = {}) {
    if (!elementName) {
        throw new Error('You must supply an element name');
    }
    const element = document.createElement(elementName);
    for (const property of Object.keys(properties)) {
        if (typeof properties[property] === 'boolean') {
            properties[property] && element.setAttribute(property, '');
        }
        else {
            properties[property] && element.setAttribute(property, properties[property]);
        }
    }
    return element;
}
export function kebabize(value) {
    return value.split('').map((letter, idx) => {
        return letter.toUpperCase() === letter
            ? `${idx !== 0 ? '-' : ''}${letter.toLowerCase()}`
            : letter;
    }).join('');
}
//# sourceMappingURL=htmlHelpers.js.map